import $ from "jquery";
class Form {

    run() {
        this.formInputs();
        this.overrideCF7();
    }

    formInputs() {
        $('.form-control').each(function () {
            $(this).removeClass('input-success');
        })

        $('.form-control').blur(function () {
            if (!$(this).val()) {
                $(this).removeClass('input-success');
            } else {
                $(this).addClass('input-success');
            }
        });
    }

    overrideCF7(){
        $(".wpcf7-response-output").each(function () {
            $(this).wrap("<div class='wrap-message'></div>");
            let structure = $(this).parent().html();
            $(this).closest(".wpcf7-form").prepend(structure);
            $(this).parent().detach();
        })
    }

}

const form = new Form();
export default form;
